import { Component, OnInit } from '@angular/core';
import { AppModeService } from '../../../angular-wallet-base/services/app-mode.service';
import { ModalController, Platform, ToastController } from '@ionic/angular';
import { MembersPortalService } from '../../../angular-wallet-base/services/members-portal.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../angular-wallet-base/store/appState';
import { PreventAuthOnResumeAction } from '../../../angular-wallet-base/actions/wallet.actions';
import { PREVENT_2FA_REAUTH_TIMEOUT, AUTH_DATA_KEY } from '../../../angular-wallet-base/constants';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { copyToClipboard, getToastPosition } from '../../../angular-wallet-base/utils';
import { TranslateService } from '@ngx-translate/core';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { StorageService } from '../../../angular-wallet-base/services/storage.service';
import { decryptData } from '../../../angular-wallet-base/utils';
import { AuthGuardService } from 'src/app/angular-wallet-base/services/auth-guard.service';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';

@Component({
  selector: 'app-enable2fa',
  templateUrl: './enable2fa.component.html',
  styleUrls: ['./enable2fa.component.scss'],
})
export class Enable2faComponent implements OnInit {
  public isDesktopMode: boolean;
  public enable2faOption: boolean = true;
  public sms2fa: boolean = false;
  public authenticatorApp2fa = false;
  public enter2faCode = false;
  public google2fresponse;
  public enableType: any;
  public twofacode;
  public userPhone: any = '';
  public lodeUser;
  public is2FAEnabled;
  public verificationType;
  public loaderFlag = false;
  public twoFaHeader = '2-Factor Authentication';

  public twoFacAuthAppClicked = false;

  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.Canada];
  selectedCountryISO = CountryISO.UnitedStates;
  lodePhoneForm: FormGroup;

  constructor(
    public appMode: AppModeService,
    private modal: ModalController,
    private portalService: MembersPortalService,
    private store: Store<AppState>,
    private platform: Platform,
    private clipboard: Clipboard,
    private toast: ToastController,
    public formBuilder: FormBuilder,
    private translate: TranslateService,
    private storage: StorageService,
    private authGuard: AuthGuardService
  ) {
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);

    this.lodePhoneForm = this.formBuilder.group({
      phone: new FormControl('', Validators.compose([
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(14)
      ]))
    });
  }
  get f() { return this.lodePhoneForm.controls; }

  async ngOnInit() {
    this.lodeUser = await this.portalService.getUserInfo();
    this.is2FAEnabled = this.lodeUser.two_factor;
    if (this.lodeUser.two_factor != false)
      this.verificationType = this.lodeUser.two_factor;
    if (this.is2FAEnabled && this.is2FAEnabled == 'sms') this.sendDisable2FASms();
  }
  closeModal(param) {
    this.modal.dismiss({ status: param });
  }
  closeOrBack() {
    this.twoFaHeader = '2-Factor Authentication';
    if (this.isDesktopMode) {
      this.closeModal(null);
    } else {
      if (this.enable2faOption && this.is2FAEnabled == false) {
        this.closeModal(null);
      } else if (this.twoFacAuthAppClicked && this.is2FAEnabled == false) {
        this.twoFacAuthAppClicked = false; 
        this.enable2faOption = true;
      } else if (this.sms2fa && this.is2FAEnabled == false) {
        this.sms2fa = false;
        this.enable2faOption = true;
      } else if (this.authenticatorApp2fa && this.is2FAEnabled == false) {
        this.authenticatorApp2fa = false;
        this.twoFacAuthAppClicked = true;
      } else if (this.enter2faCode && this.verificationType === 'sms') {
        this.twoFaHeader = 'SMS Verification';
        this.enter2faCode = false;
        this.sms2fa = true;
      } else if(this.enter2faCode && this.verificationType === 'google') {
        this.enter2faCode = false;
        this.authenticatorApp2fa = true;
      } else if (this.is2FAEnabled) {
        Logger.info('enabled');
        this.closeModal(null);
      }
    }
  }
  onPaste(e) {
    e.preventDefault();
    return false;
  }
  async sendDisable2FASms() {
    try {
      await this.portalService.sendSmsToDisable2FA();
    } catch (error) {
      Logger.info(error)
    }
  }

  smsVerification() {
    this.twoFaHeader = 'SMS Verification';
    this.verificationType = 'sms';
    this.enable2faOption = false;
    this.authenticatorApp2fa = false;
    this.enter2faCode = false;
    this.sms2fa = true;
  }
  async authenticatorApp() {
    this.twoFaHeader = '2-Factor Authentication'
    this.loaderFlag = true;
    this.verificationType = 'google';
    await this.generateCode();
    this.authenticatorApp2fa = true;
    this.enable2faOption = false;
    this.enter2faCode = false;
    this.sms2fa = false;
    this.loaderFlag = false;
    this.twoFacAuthAppClicked =false;
  }


  showGoogleAuthAppLinks() {
    this.enable2faOption = false;
    this.twoFacAuthAppClicked =true;
  }


  async generateCode() {
    try {
      this.google2fresponse = await this.portalService.generateGoogle2fa();
      // this.store.dispatch(new PreventAuthOnResumeAction({preventLogout: true, preventAuthDuration: PREVENT_2FA_REAUTH_TIMEOUT}));

    } catch (err) {
      this.presentToast('settings.toast_msgs.err_hdr', 'settings.toast_msgs.generate2fa_err_msg');
    }
  }
  async copySecret() {
    if (this.platform.is('cordova')) {
      await this.clipboard.copy(this.google2fresponse.secret);
    } else {
      copyToClipboard(this.google2fresponse.secret);
    }
    this.presentToast('settings.toast_msgs.ok_hdr', 'settings.toast_msgs.copied_2facode_msg');
  }
  async presentToast(hdr, msg) {
    const toast = await this.toast.create({
      header: await this.translate.get(hdr).toPromise(),
      message: await this.translate.get(msg).toPromise(),
      position: getToastPosition(this.platform),
      duration: 4000
    });
    await toast.present();
  }

  async sendResetCode() {
    try {
      if (this.is2FAEnabled) {
        this.sendDisable2FASms()
      } else {
        await this.portalService.sendUserSms2FA(this.userPhone.e164Number);
      }
    } catch (err) {
    }
  }
  async showEnter2fa(type) {
    this.loaderFlag = true;
    if (type == 'sms') {
      try {
        let resp = await this.portalService.sendUserSms2FA(this.userPhone.e164Number);
        if (resp.status) {
          this.presentToast('settings.toast_msgs.ok_hdr', 'settings.toast_msgs.sms2fa_success')
        }
      } catch (error) {
        this.loaderFlag = false;
      }
    }
    this.twoFaHeader = 'Confirm 2FA'
    this.enableType = type;
    this.enter2faCode = true;
    this.authenticatorApp2fa = false;
    this.enable2faOption = false;
    this.sms2fa = false;
    this.loaderFlag = false;
  }

  async submitCode() {
    this.loaderFlag = true
    if (!this.is2FAEnabled) {
      try {
        if (this.verificationType == 'sms') {
          await this.portalService.enableUserSms2FA(this.twofacode.toString());
        } else {
          await this.portalService.enableUser2FA(this.twofacode.toString());
        }

        this.presentToast('settings.toast_msgs.ok_hdr', 'settings.toast_msgs.enabled_2fa');
        this.closeModal(this.verificationType);

      } catch (err) {
        if (err.error.error == 'sms_otp_mismatch_cannot_attempt' || err.error.error == 'sms_2fa_attempt_limit_reached')
          this.presentToast('settings.toast_msgs.err_hdr', 'settings.toast_msgs.attepts_over_err_msg');
        else this.presentToast('settings.toast_msgs.err_hdr', 'settings.toast_msgs.enable2fa_err_msg');
      }
      this.loaderFlag = false;
    } else {
      try {
        if (this.is2FAEnabled == 'sms') await this.portalService.disableSmsUser2FA(this.twofacode.toString());
        else await this.portalService.disableGoogleUser2FA(this.twofacode.toString());
        this.presentToast('settings.toast_msgs.ok_hdr', 'settings.toast_msgs.disabled_2fa');
        this.closeModal(false);
      } catch (err) {
        if (err.error.error == 'sms_otp_mismatch_cannot_attempt' || err.error.error == 'sms_2fa_attempt_limit_reached')
          this.presentToast('settings.toast_msgs.err_hdr', 'settings.toast_msgs.attepts_over_err_msg');
        else this.presentToast('settings.toast_msgs.err_hdr', 'settings.toast_msgs.enable2fa_err_msg');
      }
      this.loaderFlag = false;
    }

  }

}
